<template>
  <IQOS required :title="$t('user_contacts.title')">
    <div class="profile-block mt-16">
      <div class="profile-image">
        <img :class="{
            'editing': editing
        }" :src="edit_fields.image || '/icons/worker-profile-placeholder.png'">
        <IQOSImageActions 
            class="mt-8" 
            fillSpace 
            type="avatar"
            v-model="edit_fields.image"
            v-if="editing"/>
      </div>
      <div class="profile-data ml-16 w-100">
        <BaseInput
          fullWidth
          v-model="edit_fields.name"
          :valid="!!edit_fields.name"
          :placeholder="$t('user_contacts.name_ph')"
          @blur="onEditFinish"
         :disabled="!editing"
        />
        <BaseInput
          class="mt-16"
          fullWidth
          v-model="edit_fields.phone"
          :placeholder="$t('user_contacts.phone_ph')"
          :valid="!!edit_fields.phone"
          @blur="onEditFinish"
          :disabled="!editing"
        />
      </div>
    </div>
    <template #actions>
      <IQOSActions
        :editing="editing"
        @edit="showEditUI"
        @cancel="hideEditUI"
        @accept="onEditFinish"
      />
    </template>
  </IQOS>
</template>

<script>
import AuthAPI from "@/api/auth";

export default {
  data() {
    return {
      edit_fields: {
        name: null,
        phone: null,
        image: null
      },
      editing: false
    };
  },
  methods: {
    showEditUI() {
      this.editing = true;
    },
    hideEditUI() {
      this.editing = false;
      this.reset();
    },
    onEditFinish() {
      if (!this.edit_fields.name || !this.edit_fields.phone) {
        return;
      }

      AuthAPI.updateProfile(this.edit_fields)
        .then((data) => {
          this.$store.commit("setOwnerContacts", this.edit_fields);
        })
        .catch(console.error);

      this.editing = false;
    },
    reset() {
      this.edit_fields.name = this.owner.name;
      this.edit_fields.phone = this.owner.phone;
      this.edit_fields.image = this.owner.image || null;
    },
  },
  mounted() {
    this.reset();
  },
  computed: {
    owner() {
      return this.$store.state.owner;
    },
  },
};
</script>

<style scoped>
.profile-block {
    display: flex;
}

.profile-image {
    display: flex;
    flex-flow: column;
}

.profile-image img {
    width: 80px;
    height: 80px;
    min-width: 80px;
    max-height: 80px;

    display: block;
}

.profile-image img.editing {
    width: 48px;
    height: 48px;
    max-width: 48px;
    max-height: 48px;
    min-width: 48px;
    min-height: 48px;
}
</style>